import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b627984e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b627984e&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=b627984e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b627984e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b627984e')) {
      api.createRecord('b627984e', component.options)
    } else {
      api.reload('b627984e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b627984e&scoped=true&", function () {
      api.rerender('b627984e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/zhwlDrawer/video/index.vue"
export default component.exports